import { API } from "../../../utils/api";

export async function getPeriodAPI(modelType) {
  return (await API.get(`lease/periods?modelType=${modelType}`)).data
}